var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPsychiatry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6D001891-384F-4F26-92B8-751F154381EF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First-Time-Scheduler-Link-P1-Future",
    transform: "translate(-1021, -489)",
    stroke: "#FFF0F2",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "family",
    transform: "translate(913, 455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(74, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-psychiatry",
    transform: "translate(36, 36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9644905,42.574636 C15.3973386,47.141788 7.9925159,47.141788 3.42536396,42.574636 C-1.14178799,38.0074841 -1.14178799,30.6026614 3.42536396,26.0355095 L26.0355095,3.42536396 C30.6026614,-1.14178799 38.0074841,-1.14178799 42.574636,3.42536396 C47.141788,7.9925159 47.141788,15.3973386 42.574636,19.9644905 L19.9644905,42.574636 Z M31.2695633,31.2695633 L14.7304367,14.7304367",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.880839,10.043466 C31.4128356,5.82885985 34.1044144,5.02337756 38.4668545,6.67877257",
    id: "Path-2",
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPsychiatry);
export default __webpack_public_path__ + "static/media/icon-psychiatry.cc267b7aa0a777d258f01da0b8668fc8.svg";
export { ForwardRef as ReactComponent };